import React, {useEffect, useState} from 'react'
import {Grid, FormControlLabel, Stack} from '@mui/material'
import WbOutlineButton from '../../../components/common/WbOutlineButton'
import WbButton from '../../../components/common/WbButton'
import {useParams} from 'react-router-dom'
import {surveysApi} from '../../../services'
import WbSwitch from '../../../components/common/WbSwitch'

export default function ChangeForm({
  surveyData,
  setSurveyData,
  setModalType,
  setModalOpen,
}) {
  const {token} = useParams()
  const [anoymous, setAnonymous] = useState(false)
  const [shareWithSchools, setShareWithSchools] = useState(false)

  const renderH3 = text => (
    <h3 style={{fontWeight: '600', margin: 0, display: 'in'}}>{text}</h3>
  )
  useEffect(() => {
    setAnonymous(surveyData?.annoymous === 'Fully Anonymous')
    setShareWithSchools(surveyData?.shareWithSchools === 'Shared')
  }, [surveyData])
  return (
    <Grid container>      
      {surveyData.isMatSurvey && (
        <Grid item lg={12} md={12} sm={12} xs={12} mt={3}>
          {' '}
          <FormControlLabel
            control={
              <WbSwitch
                checked={shareWithSchools}
                onChange={e => {
                  setShareWithSchools(e.target.checked)
                }}            
              ></WbSwitch>
            }
            label="Share with Schools"
          ></FormControlLabel>
        </Grid>
      )}
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <FormControlLabel
          control={
            <WbSwitch
              checked={anoymous}
              onChange={e => {
                setAnonymous(e.target.checked)
              }}
            ></WbSwitch>
          }
          label="Anonymous"
        ></FormControlLabel>
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12} mt={5}>
        <Stack direction="row" alignItem="center" justifyContent="space-between">
          <WbOutlineButton
            CustomOutlineButtonText="Cancel"
            onClick={() => {
              setModalType(null)
              setModalOpen(false)
            }}
          ></WbOutlineButton>
          <WbButton
            CustomButtonText="Save"
            onClick={async () => {
              setSurveyData({
                ...surveyData,
                annoymous: anoymous ? 'Fully Anonymous' : 'Not Anonymous',
                shareWithSchools: shareWithSchools ? 'Shared' : 'Not Shared',
              })
              
              let o = await surveysApi
                .UpdateAnonymousShareSettings(token, anoymous, shareWithSchools)
                .then(res => {
                  //  setSurveyData(res.data)
                })
              setModalType(null)
              setModalOpen(false)
            }}
          ></WbButton>
        </Stack>
      </Grid>      
    </Grid>
  )
}
